export const ACTIONS = {
  CHANGE_PASSWORD: "change_password",
  SET_LOADING: "gen/set_loading",
  GET_USER_DETAILS: "gen/get_user_details",
  CHECK_GEOFENCE_AREA: "gen/checking-geofence-area",
  GET_PACKAGES: "gen/get_packages",
  CREATE_BOOKING: "gen/create_booking",
  GET_COUPONS: "gen/get_coupons",
  GET_LEADS: "gen/get_leads",
  GET_LEAD_DETAILS: "gen/get_lead_details",
  LEAD_DETAILS_RESET: "gen/lead_details_reset",
  GET_AVAILABLE_SLOTS: "gen/get_available_slots",
  GET_CITIES: "gen/get_cities",
  GET_CENTER_INFORMATION: "gen/get_center_information",
  GET_IMAGING_TIMESLOTS: "gen/get_imaging_timeslots",
  CREATE_IMAGING_BOOKING: "gen/CREATE_IMAGING_BOOKING",
  GET_RED_COIN: "gen/get_red_coin",
  GET_SUB_CENTER_INFORMATION: "gen/get_sub_center_information",
  GET_PIN_CODE: "gen/get_pin_code",
  GET_MULTIPLE_PACKAGES: "gen/get_multiple_package",
  GET_DISPLAY_CITIES: "gen/get_display_cities",
  GET_DOCTOR_INFO_BY_ID: "gen/get_doctor_info",
  GET_AREA: "gen/get_area",
  GET_AGENTS: "gen/get_agents",
  GET_AGENTS_BY_USERGROUP: "gen/get_agents_by_usergroup",
  GET_PHLEBOS: "gen/get_phlebos",
  GET_PARTNERS: "gen/get_partners",
  UPDATE_BOOKING: "gen/update_booking",
  GET_BOOKING_LIST: "gen/get_booking_list",
  GET_LEAD_BY_ID: "gen/get_lead_by_id",
  GET_BOOKING_BY_ID: "gen/get_booking_by_id",
  CLICK_TO_CALL: "gen/click_to_call",
  GET_POSTIVE_CALLS_COMMENTS: "gen/get_postive_calls_commnets",
  ADD_POSTIVE_CALLS_COMMENT: "gen/add_comments",
  SET_COMMENTS: "gen/set_commnets",
  UPLOAD_FILE: "gen/upload",
  SEARCH_CALL: "gen/serach",
  BOOKING_RESET: "gen/booking_reset",
  ADD_COMMENT: "positive_calls/add_comment",
  CREATE_CALL: "gen/createcall",
  GET_LEAD_SOURCE: "gen/getleadsource",
  GET_RECORDINGS: "gen/get_recordings",
  GET_BOOKINGS_COMMENTS: "gen/get_bookings_commnets",
  ADD_BOOKINGS_COMMENT: "gen/add_bookings_comments",
  GET_WHATSAPP_COMMENTS: "gen/get_whatsapp_comments",
  GET_WHATSAPP_COMMENTS_BY_LEAD: "gen/get_whatsapp_comments_by_lead",
  SEND_WHATSAPP_COMMENTS: "gen/send",
  GET_CALL_STATS: "gen/get_call_stats",
  RAISE_COMPLAINT: "gen/raise_complaint",
  GET_COMPLAINTS: "gen/get_complaints",
  ASSIGN_DOCTOR: "gen/assign_doctor",
  SEND_FEEDBACK: "gen/send_feedback",
  GET_ALL_LEADS: "gen/get_all_leads",
  LEAD_TRANSFER_BY_COMMA: "gen/set_comments",
  GET_PANEL_USERS: "gen/get_panel_user",
  SAME_NUMBER_BOOKING: "gen/same_number_booking",
  GET_UNMASKED_NUMBER: "gen/get_unmasked_number",
  GET_NOTIFICATION_MESSAGE: "gen/get_notification_message",
  CREATE_ADDITIONAL_BOOKING: "gen/create_additional_booking",
  GET_FAMILY_PACKAGES: "gen/get_family_packages",
  GET_FAMILY_PACKAGES_BOOKING: "gen/get_family_packages_booking",
  CREATE_FAMILY_PACKAGES_BOOKING: "gen/create_family_packages_booking",
  GET_REPORT_DOWNLOAD: "gen/get_report_download",
  GET_REPORT_STATUS: "gen/get_report_status",
  UPLOAD_BULK_LEAD: "gen/upload_bulk_booking",
  GET_PARTNERS_ID: "gen/get_partner_id",
  GET_MAMPMYINDIA_ACCESS_TOKEN: "gen/get-mapmyindia-access-token",
  CHECK_GEOFENCE_AREA_MAMPMYINDIA: "gen/checking-geofence-area-mapmyindia",
  GET_ADDRESS_TYPE_SEATING: "gen/get_address_type_seating",
  GET_PAYMENT_SEND_LINK: "gen/get_payment_send_link",
  GET_PAYMENT_RESEND_LINK: "gen/get_payment_resend_link",
  GET_PAYMENT_CANCEL_LINK: "gen/get_payment_cancel_link",
  GET_SMS_REPORT_SEND: "gen/get_sms_report_sms",
  UPDATE_PHLEBO_STATUS: "gen/update_phlebo_status",
  GET_ADDITIONAL_BOOKING: "gen/get_additional_booking",
  GET_SIGNATURE: "gen/get_signature",
  GET_QRCODE_DATA: "gen/get_qrcode_data",
  GET_ADDITIONAL_BOOKING_LIST_WITH_TAT_TIME: "gen/get_additional_booking_list_with_tat_time",
  GET_BOOKING_LIST_WITH_TAT_TIME: "gen/get_booking_list_with_tat_time",
  GET_BOOKING_CALLS: "gen/get_booking_call",
  AUTO_ASSIGN_BOOKING: "gen/auto_assign_booking",
  GET_ASSIGNED_UNASSIGNED_BOOKING: "gen/get_assigned_unassigned_bookings",
  GET_ZONE: "gen/get_zone",
  GET_MAP_BOOKING_LIST: "gen/get_map_booking",
  GET_PHLEBO_CURRENT_LOCATION: 'gen/phlebo_current_location',
  GET_PHLEBO_COMMENTS: "gen/get_phlebo_commnets",
  UPDATE_PHLEBOS: "gen/update_phlebos",
  GET_PHLEBO_BY_PHONE: "gen/get_phlebo_by_phone",
  GET_ATTENDENCE: "gen/get_attendence",
  CREATE_NEW_PHLEBO: "gen/create_phlebo",
  GET_BIOMARKER_SCREENING: "gen/biomarker_screening",
  GET_COLLECTION_SLOT: "gen/get_collection_slot",
  GET_PACKAGE_TUBE_DETAILS: "gen/get_package_tube_details",
  CREATE_BARCODE: "gen/create_barcode",
  GET_PAYMENT_INFORMATION: "gen/get_payment_information",
  GET_FIREBASE_NOTIFICATION: "gen/get_firebase_notification",
  GET_VERIFIED_BY_LIST: "gen/get_verified_by_list",
  GET_PACKAGE_ALL_TUBE: "gen/get_package_all_tube",
  GET_RECEIVED_PACKAGES: "gen/get_received_packages",
  GET_DOCTOR_QUAL: "gen/get_doctor_qual",
  GET_DOCTOR_SPEC: "gen/get_doctor_spec",
  POST_REF_DOCTOR: "gen/post_ref_doctor",
  REF_DOCTOR_RESET: "gen/ref_doctor_reset",
  GET_REF_DOCTOR: "gen/get_ref_doctor",




};

interface GetReceivedPackages {
  type: typeof ACTIONS.GET_RECEIVED_PACKAGES;
  payload: Array<any>;
}
interface GetRefDoctor {
  type: typeof ACTIONS.GET_REF_DOCTOR;
  payload: Array<any>;
}
interface RefDoctorReset {
  type: typeof ACTIONS.REF_DOCTOR_RESET;
  payload: boolean;
}
interface PostRefDoctor {
  type: typeof ACTIONS.POST_REF_DOCTOR;
  payload: Array<any>;
}
interface GetDoctorSpec {
  type: typeof ACTIONS.GET_DOCTOR_SPEC;
  payload: Array<any>;
}
interface GetDoctorQual {
  type: typeof ACTIONS.GET_DOCTOR_QUAL;
  payload: Array<any>;
}
interface GetPackageAllTube {
  type: typeof ACTIONS.GET_PACKAGE_ALL_TUBE;
  payload: Array<any>;
}
interface GetVerifiedByList {
  type: typeof ACTIONS.GET_VERIFIED_BY_LIST;
  payload: Object;
}
interface GetFirebaseNotification {
  type: typeof ACTIONS.GET_FIREBASE_NOTIFICATION;
  payload: Array<any>;
}
interface GetPaymentInfro {
  type: typeof ACTIONS.GET_PAYMENT_INFORMATION;
  payload: Array<any>;
}
interface CreateBarcode {
  type: typeof ACTIONS.CREATE_BARCODE;
  payload: Array<any>;
}
interface GetPackageTubeDetails {
  type: typeof ACTIONS.GET_PACKAGE_TUBE_DETAILS;
  payload: Array<any>;
}
interface GetCollectionSlot {
  type: typeof ACTIONS.GET_COLLECTION_SLOT;
  payload: Array<any>;
}

interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}
interface GetBookingsTatTime {
  type: typeof ACTIONS.GET_BOOKING_LIST_WITH_TAT_TIME;
  payload: boolean;
}
interface GetAdditionalBookingsTatTime {
  type: typeof ACTIONS.GET_ADDITIONAL_BOOKING_LIST_WITH_TAT_TIME;
  payload: boolean;
}
interface GetQrCode {
  type: typeof ACTIONS.GET_QRCODE_DATA;
  payload: Array<any>;
}
interface GetAdditionalBooking {
  type: typeof ACTIONS.GET_ADDITIONAL_BOOKING;
  payload: Array<any>;
}
interface getBookingCalls {
  type: typeof ACTIONS.GET_BOOKING_CALLS;
  payload: Array<any>;
}
interface GetSignature {
  type: typeof ACTIONS.GET_SIGNATURE;
  payload: Array<any>;
}
interface GetSmsReportSend {
  type: typeof ACTIONS.GET_SMS_REPORT_SEND;
  payload: Object;
}
interface GetPaymentCancelLink {
  type: typeof ACTIONS.GET_PAYMENT_CANCEL_LINK;
  payload: Object;
}
interface GetPaymentReSendLink {
  type: typeof ACTIONS.GET_PAYMENT_RESEND_LINK;
  payload: Object;
}
interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}
interface GetUserDetails {
  type: typeof ACTIONS.GET_USER_DETAILS;
  payload: Object;
}
interface CheckGeoFenceArea {
  type: typeof ACTIONS.CHECK_GEOFENCE_AREA
  payload: Array<any>
}
interface GetPackages {
  type: typeof ACTIONS.GET_PACKAGES;
  payload: Array<any>;
}
interface CreateBooking {
  type: typeof ACTIONS.CREATE_BOOKING;
  payload: boolean;
}
interface GetCoupons {
  type: typeof ACTIONS.GET_COUPONS;
  payload: Array<any>;
}
interface GetLeads {
  type: typeof ACTIONS.GET_LEADS;
  payload: boolean;
}
interface GetPhleboCurrentLocation {
  type: typeof ACTIONS.GET_PHLEBO_CURRENT_LOCATION;
  payload: Array<any>;
}
interface GetLeadDetails {
  type: typeof ACTIONS.GET_LEAD_DETAILS;
  payload: boolean;
}
interface ResetLeadDetails {
  type: typeof ACTIONS.LEAD_DETAILS_RESET;
  payload: boolean;
}
interface GetAvailabeSlots {
  type: typeof ACTIONS.GET_AVAILABLE_SLOTS;
  payload: Object;
}
interface GetMapBooking {
  type: typeof ACTIONS.GET_MAP_BOOKING_LIST;
  payload: Array<any>;
}
interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}
interface GetCenterInfo {
  type: typeof ACTIONS.GET_CENTER_INFORMATION;
  payload: Array<any>;
}
interface GetImagingTimeSlots {
  type: typeof ACTIONS.GET_IMAGING_TIMESLOTS;
  payload: Array<any>;
}
interface CreateImagingBooking {
  type: typeof ACTIONS.CREATE_IMAGING_BOOKING;
  payload: boolean;
}
interface GetRedCoin {
  type: typeof ACTIONS.GET_RED_COIN;
  payload: Array<any>;
}
interface GetSubCenterInformation {
  type: typeof ACTIONS.GET_SUB_CENTER_INFORMATION;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface GetMultiplepackage {
  type: typeof ACTIONS.GET_MULTIPLE_PACKAGES;
  payload: Array<any>;
}
interface GetDisplayCities {
  type: typeof ACTIONS.GET_DISPLAY_CITIES;
  payload: Array<any>;
}
interface getDoctorInfoById {
  type: typeof ACTIONS.GET_DOCTOR_INFO_BY_ID;
  payload: object;
}

interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface GetPartnerId {
  type: typeof ACTIONS.GET_PARTNERS_ID;
  payload: Array<any>;
}
interface GetReportStatus {
  type: typeof ACTIONS.GET_REPORT_STATUS;
  payload: Array<any>;
}
interface UploadBulkLead {
  type: typeof ACTIONS.UPLOAD_BULK_LEAD;
  payload: Array<any>;
}
interface GetUserGetails {
  type: typeof ACTIONS.GET_USER_DETAILS;
  payload: Array<any>;
}
interface CreatePhlebo {
  type: typeof ACTIONS.CREATE_NEW_PHLEBO;
  payload: boolean;
}
interface GetReportDownload {
  type: typeof ACTIONS.GET_REPORT_DOWNLOAD;
  payload: Object;
}
interface CheckGeoFenceArea {
  type: typeof ACTIONS.CHECK_GEOFENCE_AREA
  payload: Array<any>
}
interface CreateAdditionalBooking {
  type: typeof ACTIONS.CREATE_ADDITIONAL_BOOKING;
  payload: Object;
}
interface GetUnmaskedNumber {
  type: typeof ACTIONS.GET_UNMASKED_NUMBER;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}

interface UploadFile {
  type: typeof ACTIONS.UPLOAD_FILE;
  payload: Object;
}

interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}
interface GetRedCoins {
  type: typeof ACTIONS.GET_RED_COIN
  payload: Array<any>
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}

interface GetAgents {
  type: typeof ACTIONS.GET_AGENTS;
  payload: Array<any>;
}

interface GetPhlebo {
  type: typeof ACTIONS.GET_PHLEBOS;
  payload: Array<any>;
}

interface SetComments {
  type: typeof ACTIONS.SET_COMMENTS;
  payload: Object;
}

interface GetPositiveCallsComments {
  type: typeof ACTIONS.GET_POSTIVE_CALLS_COMMENTS;
  payload: Object;
}

interface AddPositiveCallsComments {
  type: typeof ACTIONS.ADD_POSTIVE_CALLS_COMMENT;
  payload: Object;
}

interface ClickToCall {
  type: typeof ACTIONS.CLICK_TO_CALL;
  payload: Array<any>;
}

interface GetPackages {
  type: typeof ACTIONS.GET_PACKAGES;
  payload: Array<any>;
}

interface GetPartners {
  type: typeof ACTIONS.GET_PARTNERS;
  payload: Array<any>;
}

interface GetCoupons {
  type: typeof ACTIONS.GET_COUPONS;
  payload: Array<any>;
}

interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}

interface CreateBooking {
  type: typeof ACTIONS.CREATE_BOOKING;
  payload: boolean;
}

interface UpdateBooking {
  type: typeof ACTIONS.UPDATE_BOOKING;
  payload: boolean;
}

interface GetBookings {
  type: typeof ACTIONS.GET_BOOKING_LIST;
  payload: boolean;
}

interface GetBookingById {
  type: typeof ACTIONS.GET_BOOKING_BY_ID;
  payload: boolean;
}

interface GetLeads {
  type: typeof ACTIONS.GET_LEADS;
  payload: boolean;
}

interface GetLeadDetails {
  type: typeof ACTIONS.GET_LEAD_DETAILS;
  payload: boolean;
}

interface GetLeadById {
  type: typeof ACTIONS.GET_LEAD_BY_ID;
  payload: boolean;
}

interface ResetLeadDetails {
  type: typeof ACTIONS.LEAD_DETAILS_RESET;
  payload: boolean;
}

interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}
interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}
interface GetPhlebo {
  type: typeof ACTIONS.GET_PHLEBOS;
  payload: Array<any>;
}

interface GetAgents {
  type: typeof ACTIONS.GET_AGENTS;
  payload: Array<any>;
}

interface SetComments {
  type: typeof ACTIONS.SET_COMMENTS;
  payload: Object;
}

interface GetPositiveCallsComments {
  type: typeof ACTIONS.GET_POSTIVE_CALLS_COMMENTS;
  payload: Object;
}

interface AddPositiveCallsComments {
  type: typeof ACTIONS.ADD_POSTIVE_CALLS_COMMENT;
  payload: Object;
}
interface ClickToCall {
  type: typeof ACTIONS.CLICK_TO_CALL;
  payload: Array<any>;
}

interface GetPackages {
  type: typeof ACTIONS.GET_PACKAGES;
  payload: Array<any>;
}

interface GetPartners {
  type: typeof ACTIONS.GET_PARTNERS;
  payload: Array<any>;
}

interface GetCoupons {
  type: typeof ACTIONS.GET_COUPONS;
  payload: Array<any>;
}

interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}

interface CreateBooking {
  type: typeof ACTIONS.CREATE_BOOKING;
  payload: boolean;
}

interface UpdateBooking {
  type: typeof ACTIONS.UPDATE_BOOKING;
  payload: boolean;
}

interface GetBookings {
  type: typeof ACTIONS.GET_BOOKING_LIST;
  payload: boolean;
}

interface GetBookingById {
  type: typeof ACTIONS.GET_BOOKING_BY_ID;
  payload: boolean;
}

interface GetLeads {
  type: typeof ACTIONS.GET_LEADS;
  payload: boolean;
}

interface GetLeadDetails {
  type: typeof ACTIONS.GET_LEAD_DETAILS;
  payload: boolean;
}

interface GetLeadById {
  type: typeof ACTIONS.GET_LEAD_BY_ID;
  payload: boolean;
}

interface ResetLeadDetails {
  type: typeof ACTIONS.LEAD_DETAILS_RESET;
  payload: boolean;
}
interface SearchCall {
  type: typeof ACTIONS.SEARCH_CALL;
  payload: Object;
}
interface SearchCall {
  type: typeof ACTIONS.SEARCH_CALL;
  payload: Object;
}
interface GetAgentByUserGroup {
  type: typeof ACTIONS.GET_AGENTS_BY_USERGROUP;
  payload: Object;
}
interface SameNumberBooking {
  type: typeof ACTIONS.SAME_NUMBER_BOOKING;
  payload: Object;
}
interface GetNotificationMessage {
  type: typeof ACTIONS.GET_NOTIFICATION_MESSAGE;
  payload: Array<any>;
}
interface GetFamilyPackages {
  type: typeof ACTIONS.GET_FAMILY_PACKAGES;
  payload: Array<any>;
}

interface GetFamilyPackagesBooking {
  type: typeof ACTIONS.GET_FAMILY_PACKAGES_BOOKING;
  payload: Array<any>;
}

interface CreateFamilyPackageBooking {
  type: typeof ACTIONS.CREATE_FAMILY_PACKAGES_BOOKING;
  payload: Object;
}
interface GetCenterInfo {
  type: typeof ACTIONS.GET_CENTER_INFORMATION;
  payload: Array<any>;
}
interface GetSubCenterInformation {
  type: typeof ACTIONS.GET_SUB_CENTER_INFORMATION;
  payload: Array<any>;
}
interface GetImagingTimeSlots {
  type: typeof ACTIONS.GET_IMAGING_TIMESLOTS;
  payload: Array<any>;
}
interface CreateImagingBooking {
  type: typeof ACTIONS.CREATE_IMAGING_BOOKING;
  payload: boolean;
}
interface GetMultiplepackage {
  type: typeof ACTIONS.GET_MULTIPLE_PACKAGES;
  payload: Array<any>;
}
interface GetDisplayCities {
  type: typeof ACTIONS.GET_DISPLAY_CITIES;
  payload: Array<any>;
}
interface GetMapMyIndiaAccessToken {
  type: typeof ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN
  payload: Array<any>
}
interface GetAddressTypeSeating {
  type: typeof ACTIONS.GET_ADDRESS_TYPE_SEATING;
  payload: Object;
}
interface CheckGeoFenceAreaMapMyIndia {
  type: typeof ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA
  payload: Array<any>
}
interface GetPaymentSendLink {
  type: typeof ACTIONS.GET_PAYMENT_SEND_LINK;
  payload: Object;
}
interface UpdatePhleboStatus {
  type: typeof ACTIONS.UPDATE_PHLEBO_STATUS;
  payload: Array<any>;
}

interface AutoAssignBooking {
  type: typeof ACTIONS.AUTO_ASSIGN_BOOKING
  payload: Array<any>
}
interface GetAssignedUnassignedBooking {
  type: typeof ACTIONS.GET_ASSIGNED_UNASSIGNED_BOOKING;
  payload: Array<any>;
}
interface GetZone {
  type: typeof ACTIONS.GET_ZONE;
  payload: Object;
}
interface GetPhleboComment {
  type: typeof ACTIONS.GET_PHLEBO_COMMENTS;
  payload: Object;
}
interface UpdatePhlebos {
  type: typeof ACTIONS.UPDATE_PHLEBOS;
  payload: Object;
}
interface GetPhleboByPhone {
  type: typeof ACTIONS.GET_PHLEBO_BY_PHONE;
  payload: Object;
}
interface GetAttendence {
  type: typeof ACTIONS.GET_ATTENDENCE;
  payload: Object;
}
interface GetBiomarkerScreening {
  type: typeof ACTIONS.GET_BIOMARKER_SCREENING;
  payload: Object;
}

export type PhlebognadminTypes =
  | ChangePassword
  | SetLoading
  | GetUserDetails
  | CheckGeoFenceArea
  | GetPackages
  | CreateBooking
  | GetLeads
  | GetLeadDetails
  | ResetLeadDetails
  | GetAvailabeSlots
  | GetCities
  | GetCenterInfo
  | GetImagingTimeSlots
  | CreateImagingBooking
  | GetRedCoin
  | GetSubCenterInformation
  | GetPinCode
  | GetMultiplepackage
  | GetDisplayCities
  | getDoctorInfoById
  | GetCoupons
  | SearchCall
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | GetAgents
  | GetPhlebo
  | GetAgentByUserGroup
  | GetPackages
  | CreateBooking
  | UpdateBooking
  | GetPartners
  | GetCoupons
  | GetBookings
  | GetBookingById
  | SetLoading
  | GetLeadDetails
  | GetLeads
  | GetLeadById
  | ResetLeadDetails
  | ClickToCall
  | GetPositiveCallsComments
  | AddPositiveCallsComments
  | SetComments
  | UploadFile
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | GetAgents
  | GetPhlebo
  | GetPackages
  | CreateBooking
  | UpdateBooking
  | GetPartners
  | GetCoupons
  | GetBookings
  | GetBookingById
  | SetLoading
  | GetLeadDetails
  | GetLeads
  | GetLeadById
  | ResetLeadDetails
  | ClickToCall
  | GetPositiveCallsComments
  | AddPositiveCallsComments
  | SetComments
  | SearchCall
  | SameNumberBooking
  | GetNotificationMessage
  | GetUnmaskedNumber
  | CreateAdditionalBooking
  | CheckGeoFenceArea
  | GetFamilyPackages
  | GetFamilyPackagesBooking
  | CreateFamilyPackageBooking
  | GetReportDownload
  | GetReportStatus
  | GetUserGetails
  | UploadBulkLead
  | GetPartnerId
  | GetRedCoins
  | GetCenterInfo
  | GetSubCenterInformation
  | GetImagingTimeSlots
  | CreateImagingBooking
  | GetMultiplepackage
  | GetDisplayCities
  | GetMapMyIndiaAccessToken
  | CheckGeoFenceAreaMapMyIndia
  | GetAddressTypeSeating
  | GetSmsReportSend
  | GetPaymentCancelLink
  | GetPaymentReSendLink
  | GetPaymentSendLink
  | UpdatePhleboStatus
  | GetSignature
  | GetBookingsTatTime
  | GetAdditionalBookingsTatTime
  | GetQrCode
  | GetAdditionalBooking
  | getBookingCalls
  | AutoAssignBooking
  | GetAssignedUnassignedBooking
  | GetZone
  | GetMapBooking
  | GetPhleboCurrentLocation
  | GetPhleboComment
  | UpdatePhlebos
  | GetPhleboByPhone
  | GetAttendence
  | CreatePhlebo
  | GetBiomarkerScreening
  | GetCollectionSlot
  | GetPackageTubeDetails
  | CreateBarcode
  | GetPaymentInfro
  | GetFirebaseNotification
  | GetVerifiedByList
  | GetPackageAllTube
  | GetReceivedPackages
  | GetDoctorQual
  | GetDoctorSpec
  | PostRefDoctor
  | RefDoctorReset
  | GetRefDoctor








